<template>
    <div>
        <el-dialog append-to-body v-mobile-dialog v-for="x in disclaimers" :key="x.cookie"
                   :title="x.title"
                   :visible.sync="x.visible"
                   width="75%">
            <h4>{{x.title}}</h4>
            <p></p>
            <div v-html="x.text"></div>
            <span slot="footer" class="dialog-footer">
            <el-checkbox v-model="x.ivread" class="pull-left" style="font-size: 24px;">我已阅读</el-checkbox>
            <el-button type="primary" @click="closeDisclaimer(x)">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>

    import VueCookie from "vuecookie";
    import {mapState} from "vuex"

    export default {
        name: "disclaimer",
        data() {
            return {
                disclaimers: []
            }
        },
        computed: {
            ...mapState(['preset']),
        },
        watch: {
            preset: {
                handler(newVal) {
                    if (newVal.app && newVal.app.disclaimers) {
                        const disclaimers = [];
                        newVal.app.disclaimers.forEach(function (x) {
                            let one = {cookie:x.cookie,title:x.title,text:x.text,visible:false,ivread:false};
                            if (!VueCookie.get(x.cookie)) {
                                one.visible = true;
                                one.ivread = false;
                            }
                            disclaimers.push(one);
                        });
                        this.disclaimers = disclaimers;
                    }
                },
                deep: true,
                immediate: true,
            }
        },
        methods: {
            closeDisclaimer(disclaimer) {
                disclaimer.visible = false;
                if (disclaimer.ivread) {
                    VueCookie.set(disclaimer.cookie, 1, {expires: '10Y'});
                }
            },
        },
    }
</script>

<style scoped>

</style>
